import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '@env/environment';
import { QualtricsLoaderService } from './qualtrics-loader.service';

/**
 * Decide en qué rutas vive la encuesta de Qualtrics (CI-23287).
 *
 * La lista de rutas está en `environment.qualtrics.routes`, así que habilitar la encuesta en
 * otra pantalla es configuración y no código.
 */
@Injectable({
  providedIn: 'root',
})
export class QualtricsRouteWatcherService implements OnDestroy {
  private subscription: Subscription | null = null;

  constructor(
    private readonly _router: Router,
    private readonly _qualtricsLoader: QualtricsLoaderService
  ) {}

  /** Arranca la vigilancia de rutas. Idempotente y sin efecto si el flag está apagado. */
  start(): void {
    if (this.subscription || !environment.qualtrics.enabled) {
      return;
    }

    this.subscription = this._router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.handleNavigation(event.urlAfterRedirects || event.url));
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscription = null;
    this._qualtricsLoader.unmount();
  }

  private handleNavigation(url: string): void {
    if (this.isSurveyRoute(url)) {
      void this._qualtricsLoader.mount();
      return;
    }

    this._qualtricsLoader.unmount();
  }

  /** Se ignoran query string y fragmento: la ruta es la que decide, no sus parámetros. */
  private isSurveyRoute(url: string): boolean {
    const [path] = url.split(/[?#]/);
    return environment.qualtrics.routes.includes(path);
  }
}
